<template>
    <div id="user-accesses-form">
        <div class="tw-mt-4" v-for="(access, index) in accessItems">
            <div class="tw-flex tw-gap-2">
                <bordered-input :disabled="!! access.revoked_at">
                    <template #label>
                        <label :for="'name-' + index">
                            Zugang
                        </label>
                    </template>
                    <template #input>
                        <input name="name"
                               type="text"
                               v-model="access.name"
                               placeholder="Zugang"
                        >
                    </template>
                </bordered-input>

                <button v-if="! access.revoked_at" class="cu-btn-default" type="button" @click="revokeAccess(access)" title="Zugang zurückgeben oder entziehen">
                    <i class="fa fa-angle-double-right"></i>
                </button>

                <button v-if="!! access.revoked_at" class="cu-btn-default" type="button" @click="restoreAccess(access)" title="Zugang wiederherstellen">
                    <i class="fa fa-undo"></i>
                </button>

<!--                <button class="cu-btn-danger" type="button" @click="deleteRow(index)" title="Zeile Löschen">-->
<!--                    <i class="fa fa-trash"></i>-->
<!--                </button>-->
            </div>

            <div v-if="FormUtils.hasError(errors, `accesses.${index}.*`)" class="tw-text-danger-primary">
                {{ FormUtils.getErrorMessage(errors, `accesses.${index}.*`)}}
            </div>
        </div>

        <div class="tw-mt-4">
            <button class="cu-btn-default" type="button" @click="addRow">
                <i class="fa fa-plus"></i>
                Zeile hinzufügen
            </button>
        </div>

        <div class="tw-mt-8 tw-flex">
            <button type="button" class="cu-btn" @click="save">
                <i class="fa fa-save"></i> Speichern
            </button>

            <button type="button" class="cu-btn-default tw-ml-1" @click="abort">
                <i class="fa fa-times"></i> Abbrechen
            </button>
        </div>
    </div>
</template>

<script>
import BorderedInput from "../Redesign/BorderedInput";
import moment from "moment";
import axios from "axios";
import FormUtils from "../../Support/FormUtils";

export default {
    components: {
        BorderedInput,
    },

    props: {
        user: {
            required: true,
            type: Object,
        },

        accesses: {
            type: Array,
            required: true,
        },

        saveEndpoint: {
            type: String,
            required: true,
        },

        abortUrl: {
            type: String,
            required: true,
        },

        changedUrl: {
            type: String,
            required: true,
        }
    },

    data() {
        return {
            FormUtils: FormUtils,
            accessItems: [...this.accesses],
            errors: null,
        }
    },

    methods: {
        addRow() {
            this.accessItems.push(this.emptyItem());
        },

        emptyItem() {
            return {
                id: null,
                name: null,
                revoked_at: null,
            };
        },

        // deleteRow(index) {
        //     this.accessItems.splice(index, 1);
        // },

        revokeAccess(access) {
            access.revoked_at = moment().format('YYYY-MM-DD HH:mm:ss');
        },

        restoreAccess(access) {
            access.revoked_at = null;
        },

        abort() {
            window.location.href = this.abortUrl;
        },

        save() {
            axios
                .patch(this.saveEndpoint, {
                    accesses: this.accessItems
                })
                .then(response => {
                    window.location.href = this.changedUrl;
                })
                .catch(error => {
                    // handle errors
                    this.errors = error?.response?.data?.errors;
                });
        }
    },

    mounted() {
        if (this.accessItems.length === 0) {
            this.addRow();
        }
    }
}
</script>
